import React, {useEffect, useState} from 'react';
import {
    authAPI,
} from "../services/AuthService";
import {Button, DatePicker, Input, Space, Spin, Tag, Typography, Upload} from "antd";
import {
    ArrowLeftOutlined,
    EditOutlined,
    SendOutlined,
    ToolOutlined,
    LikeOutlined,
    SaveOutlined
} from "@ant-design/icons";
import {Navigate, useLocation} from "react-router-dom";
import {ObjectModel} from "../models/ObjectModel";
import {objectAPI} from "../services/ObjectService";
import {EquipmentModel} from "../models/EquipmentModel";
import {taskAPI} from "../services/TaskService";
import {host, port, secure} from "../config/config";
import {Navigation} from "../components/ViewTaskScreen/Navigation";
import {MessageCard} from "../components/ViewTaskScreen/MessageCard";
import {NoMessageCard} from "../components/ViewTaskScreen/NoMessageCard";
import {messageAPI} from "../services/MessageService";
import {MessageModel} from "../models/MessageModel";
import {ConfirmTaskCompleteModal} from "../components/TaskScreen/ConfirmTaskCompleteModal";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const {Text} = Typography;
export const ViewTaskScreen: React.FC = () => {
    let location = useLocation();
    const [updateTaskStatusRequest, {
        isLoading: isLoadingUpdateTaskStatusRequest,
        isError: isErrorUpdateTaskStatusRequest,
        isSuccess: isSuccessUpdateTaskStatusRequest,
    }] = taskAPI.useUpdateTaskStatusMutation();
    const [createMessageRequest, {
        isLoading: isLoadingCreateMessageRequest,
        isError: isErrorCreateMessageRequest,
        isSuccess: isSuccessCreateMessageRequest,
    }] = messageAPI.useCreateMessageMutation();
    const [getMessagesRequest, {
        data: dataGetMessagesRequest,
        isError: isErrorCGetMessagesRequest,
    }] = messageAPI.useGetUserMessagesMutation();
    const [getObjectsRequest, {
        data: dataGetObjectsRequest,
        isLoading: isLoadingDataGetObjectsRequest,
        isError,
    }] = objectAPI.useGetMyObjectsMutation();
    const [getTaskByIdRequest, {
        data: dataGetTaskByIdRequest,
        isLoading: isLoadingGetTaskById,
        isError: isErrorGetTaskById,
    }] = taskAPI.useGetTaskByIdMutation();
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') {
            localStorage.clear()
            setRedirectToLogin(true)
        }
    }, [statusVerifyTokenRequest])
    // -----
    const [taskId,] = useState<string | undefined>(location.pathname.split('/').at(-1));
    const [userRole,] = useState<string>(() => {
        if (localStorage.getItem('role') === '2') return 'executor'
        else return 'client'
    });
    const [redirectToUpdateTask, setRedirectToUpdateTask] = useState<boolean>(false);
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    const [redirectToTasks, setRedirectToTasks] = useState<boolean>(false);
    const [selectedObject, setSelectedObject] = useState<string>('');
    const [selectedEquipment, setSelectedEquipment] = useState<string>('');
    const [title, setTitle] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [completedDate, setCompletedDate] = useState<string>();
    const [currentMenuItem, setCurrentMenuItem] = useState('task');
    const [message, setMessage] = useState<string>();
    const [messages, setMessages] = useState<MessageModel[]>();
    const [visibleConfirmTaskCompleteModal, setVisibleConfirmTaskCompleteModal] = useState<boolean>(false)
;    useEffect(() => {
        getObjectsRequest()
        if (taskId) {
            getTaskByIdRequest(taskId)
            getMessagesRequest(taskId)
        }
    }, []);
    useEffect(() => {
        if (dataGetTaskByIdRequest && dataGetObjectsRequest) {
            if (dataGetTaskByIdRequest.equipment) {
                const equipmentCode = dataGetTaskByIdRequest.equipment.split("#")[1]
                const equipmentName = dataGetTaskByIdRequest.equipment.split("#")[0]
                const object: ObjectModel | undefined = dataGetObjectsRequest.find((object: ObjectModel) =>
                    object.equipments.find((equipment: EquipmentModel) =>
                        equipment.name === equipmentName && equipment.code === equipmentCode))
                if (object)
                    setSelectedObject(object.name)
                else { // @ts-ignore
                    setSelectedObject(dataGetTaskByIdRequest.object)
                }
                setSelectedEquipment(equipmentName + '#' + equipmentCode)
                setTitle(dataGetTaskByIdRequest.title)
                setDescription(dataGetTaskByIdRequest.description)
                setCompletedDate(dataGetTaskByIdRequest.completedDate)
            }
        }
    }, [dataGetTaskByIdRequest, dataGetObjectsRequest])
    useEffect(() => {
        if (dataGetMessagesRequest) setMessages(dataGetMessagesRequest)
    }, [[dataGetMessagesRequest]])
    useEffect(() => {
        if (isSuccessCreateMessageRequest) {
            setMessage('')
            if (taskId) getMessagesRequest(taskId)
        }
    }, [isSuccessCreateMessageRequest])
    useEffect(() => {
        if (isSuccessUpdateTaskStatusRequest && taskId) getTaskByIdRequest(taskId)
    }, [isSuccessUpdateTaskStatusRequest])
    const sendMessageHandler: () => void = () => {
        if (message && taskId) {
            const messageModel: MessageModel = {
                message,
                taskId: taskId as unknown as number,
            }
            createMessageRequest(messageModel);
        }
    }
    const updateStatusHandler: () => void = () => {
        if (dataGetTaskByIdRequest?.status === 'inProcess') {
            setVisibleConfirmTaskCompleteModal(true)

        }
        else {
            const task: any = {
                taskId,
                status: dataGetTaskByIdRequest?.status === 'created' ? 'inProcess' : 'completed',
            }
            updateTaskStatusRequest(task)
            setTimeout(() => taskId && getTaskByIdRequest(taskId), 500)
        }
    }
    return (
        <div style={{padding: 5}}>
            <ConfirmTaskCompleteModal taskId={taskId} getTaskByIdRequest={getTaskByIdRequest} updateTaskStatusRequest={updateTaskStatusRequest} visible={visibleConfirmTaskCompleteModal} setVisible={setVisibleConfirmTaskCompleteModal} />
            {redirectToUpdateTask &&
                <Navigate to={`/my/updateTask/${taskId}`} replace={false}/>}
            {redirectToLogin && <Navigate to="/login" replace={false}/>}
            {redirectToTasks && <Navigate to={`/my`} replace={false}/>}
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '15px'}}>
                <Button onClick={() => setRedirectToTasks(true)} type="primary"
                        icon={<ArrowLeftOutlined/>}>
                    Назад
                </Button>
                {(currentMenuItem === 'task' && userRole === 'client') &&
                    <Button onClick={() => setRedirectToUpdateTask(true)} type="primary"
                            icon={<EditOutlined/>}>
                        Редактировать
                    </Button>}
                {(currentMenuItem === 'task' && userRole === 'executor' && dataGetTaskByIdRequest && (dataGetTaskByIdRequest.status === 'created' || dataGetTaskByIdRequest.status === 'inProcess')) &&
                    <Button onClick={updateStatusHandler} type="primary" disabled={isLoadingUpdateTaskStatusRequest}
                            icon={dataGetTaskByIdRequest.status === 'created' ? <ToolOutlined/> : <LikeOutlined/>}>
                        {dataGetTaskByIdRequest.status === 'created' && "Взять в работу"}
                        {dataGetTaskByIdRequest.status === 'inProcess' && "Выполнить"}
                    </Button>}
                {dataGetTaskByIdRequest && dataGetTaskByIdRequest.status === 'completed' &&
                    <Tag style={{display: 'flex', alignItems: 'center'}}>Выполнено</Tag>}
            </div>
            {currentMenuItem === 'task' ?
                <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                    {(isLoadingGetTaskById || isLoadingDataGetObjectsRequest) ?
                        <div style={{display: 'flex', justifyContent: 'center', marginTop: '40vh'}}><Spin
                            size={'large'}/>
                        </div> :
                        <>
                            <Text style={{fontFamily: 'Roboto'}}>{selectedObject}</Text>
                            <Text style={{fontFamily: 'Roboto'}}>{selectedEquipment}</Text>
                            <Text style={{fontFamily: 'Roboto'}}>{title}</Text>
                            <Text style={{fontFamily: 'Roboto'}}>{description}</Text>
                            <Text style={{fontFamily: 'Roboto'}}>Дата выполнения заявки:</Text>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                {completedDate ?
                                    // @ts-ignore
                                    <DatePicker defaultValue={dayjs(completedDate?.slice(0, 11), "YYYY-MM-DD")} style={{width: '82vw'}} />
                                        :
                                    // @ts-ignore
                                    <DatePicker style={{width: '82vw'}} />
                                }
                                <Button style={{width: '10vw'}} icon={<SaveOutlined/>}/>
                            </div>
                            <Upload
                                // @ts-ignore
                                defaultFileList={dataGetTaskByIdRequest?.photos.map((photoId: string) => (
                                    {
                                        uid: photoId,
                                        name: `photo${photoId}.png`,
                                        status: 'success',
                                        url: `${secure}://${host}${port}/tasks/getPhotoById/${photoId}`,
                                        percent: 100,
                                    }
                                ))}
                                style={{width: '95vw'}}
                                multiple
                                maxCount={3}
                                listType="picture">
                            </Upload>
                        </>
                    }
                </Space>
                :
                <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                    {(isLoadingGetTaskById || isLoadingDataGetObjectsRequest) ?
                        <div style={{display: 'flex', justifyContent: 'center', marginTop: '40vh'}}><Spin
                            size={'large'}/>
                        </div> :
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            {messages?.length === 0 ?
                                <NoMessageCard/>
                                :
                                messages?.map((message: MessageModel) => {
                                    if (message.date && message.fromMe !== undefined)
                                        return (
                                            <MessageCard message={message.message} date={message.date}
                                                         fromMe={message.fromMe}/>
                                        )
                                })
                            }
                            <div style={{display: 'flex', marginTop: 10}}>
                                <Input placeholder="Напишите сообщение..." value={message} onChange={(e) => {
                                    setMessage(e.target.value)
                                }}/>
                                <Button disabled={isLoadingCreateMessageRequest} onClick={sendMessageHandler}
                                        style={{marginLeft: 5}} icon={<SendOutlined/>}>Отправить</Button>
                            </div>
                        </div>
                    }
                </Space>
            }
            <Navigation setCurrentMenuItem={setCurrentMenuItem} currentMenuItem={currentMenuItem}/>
        </div>
    );
};